export enum EmployeeStatusType {
  CREATED = 139,
  IN_TRAINING = 174
}
